<mat-card class="grid-card" id="page-content">
    <mat-card-content class="grid-card-content">

        <mat-grid-list cols="4" rowHeight="100px">
            <mat-grid-tile colspan="2">
                <mat-form-field appearance="outline">
                    <mat-label>{{'SEARCH' | translate}}</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Search" #filter>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="1">
            </mat-grid-tile>
            <mat-grid-tile colspan="1">
                <button [matMenuTriggerFor]="menu" mat-button class="btn-secondary" color="primary"
                    [disabled]="isExportDisabled">
                    <mat-icon class="primary">print</mat-icon>
                    Print
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="downloadAllAsPdf('all')" [disabled]="isExportDisabled">
                        <mat-icon>picture_as_pdf</mat-icon>
                        All as PDF
                    </button>
                    <button mat-menu-item (click)="downloadAllAsPdf('current')" [disabled]="isExportDisabled">
                        <mat-icon>picture_as_pdf</mat-icon>
                        Current as PDF
                    </button>
                    <button mat-menu-item (click)="downloadAllAsExcel('all')" [disabled]="isExportDisabled">
                        <mat-icon>grid_on</mat-icon>
                        All as CSV
                    </button>
                    <button mat-menu-item (click)="downloadAllAsExcel('current')" [disabled]="isExportDisabled">
                        <mat-icon>grid_on</mat-icon>
                        Current as CSV
                    </button>
                </mat-menu>
                <button mat-button class="btn-primary ml-1" color="primary" (click)="add()">
                    <mat-icon>add_circle</mat-icon>
                    Add New Mouza
                </button>
            </mat-grid-tile>
        </mat-grid-list>


        <div class="table-responsive table-container">
        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="sr">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'Sr.no' | translate}} </th>
                <td mat-cell *matCellDef="let row; let i=index">{{i+1}} </td>
            </ng-container>
            <ng-container matColumnDef="division">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'DIVISION' | translate }}
                </th>
                <td mat-cell *matCellDef="let row">
                    {{ getDivisionId(row) !== null ? (getDivisionId(row) | segmentPipe:divisionList) : '' }}
                </td>
            </ng-container>
            <ng-container matColumnDef="district">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'DISTRICT' | translate }}
                </th>
                <td mat-cell *matCellDef="let row">
                    {{ getDivisionId(row) !== null ? (getDivisionId(row) | segmentPipe:divisionList) : '' }}
                </td>
            </ng-container>
            <ng-container matColumnDef="tehsil">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'TEHSIL' | translate }}
                </th>
                <td mat-cell *matCellDef="let row">
                    {{ row.parentAdminStrId | segmentPipe:tehsilList }}
                </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'MOUZA_NAME' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.name}} </td>
            </ng-container>
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'DESCRIPTION' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.description}} </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> {{'ACTION' | translate}} </th>
                <td mat-cell *matCellDef="let row; let i=index;">
                    <button mat-icon-button color="primary" (click)=edit(row,i) title="Edit">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)=delete(row.adminStrId) title="Drop">
                        <mat-icon>delete_forever</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell mat-cell-left-padding-10" colspan="6">{{'NO_DATA_FOUND' | translate}}
                    "{{filter.value}}"</td>
            </tr>
        </table>
        </div>

        <mat-paginator [pageSizeOptions]="config.pageSizeOptionsList" showFirstLastButtons></mat-paginator>
    </mat-card-content>

</mat-card>